<template>
<div>
    <div v-if="busy">
        <BlockUI class="line">
            <div class="new-loading">
            <span></span>
            <span></span>
            <span></span>
            </div>
        </BlockUI>
    </div>
    <div v-else class="line-template-consign manage-sender px-3 kanit position-relative">
        <div v-for="sender in senders" :key="sender.id" class="d-flex flex-row mt-2 pt-3 border-color-top clean-background">
            <div class="col-1" @click="changeSelectRadio(sender.id)">
                <b-form-radio v-model="selectedRadio" name="some-radios" :value="sender.id"></b-form-radio>
            </div>
            <div class="col-9" @click="changeSelectRadio(sender.id)">
                <div class="header-label">
                    {{ sender.name }} | {{ sender.tel }}
                </div>
                <div class="detail-address text-line-muted">
                    {{ sender.address }}
                </div>
                <div class="tags mt-2">
                    <div v-if="sender.active_address" class="box-tag tags-address-active">
                        ที่อยู่เริ่มต้น
                    </div>
                    <div v-if="sender.tags === 'home'" class="tags-non-active box-tag ml-2">
                        บ้าน
                    </div>
                    <div v-if="sender.tags === 'office'" class="tags-non-active box-tag ml-2">
                        บ้าน
                    </div>
                </div>
            </div>
            <div class="col-1">
                <div class="">
                    <img :src="icon.penceilEdit.url" alt="pancil" @click="activeEditSender(sender.id)">
                </div>
            </div>
        </div>
        <div class="line-fixed-bottom my-2 w-100 px-3 group-input">
            <div class="d-flex flex-column">
                <b-button variant="outline-line-primary" class="mt-2 hover-button-primary" block @click="addingSender">
                    เพิ่มที่อยู่ใหม่
                </b-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { switchLiff, formatLiff } from "@/constants/Lineliff"
const context_line = JSON.parse(localStorage.getItem('context_line'))
export default {
    metaInfo: {
      title: 'เลือกที่อยู่ผู้ส่ง',
    },
    data() {
        return {
            busy: true,
            icon: {
                penceilEdit: {
                    url: require("../../assets/icon/penciledit.svg")
                }
            },
            selectedRadio: '',
            senders: []
        }
    },
    methods: {
        addingSender() {
            const queryParam = '?action=' + 'addSender'
            switchLiff(encodeURIComponent(queryParam), 'FULL', 'addSender')
        },
        activeEditSender(key) {
            const queryParam = '?senderId=' + key + '&action=' + 'editSender'
            switchLiff(encodeURIComponent(queryParam), 'FULL', 'editSender')
        },
        async changeSelectRadio(key) {
            this.selectedRadio = key
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            await this.$http.post(this.$API_URL + `/line/set/defaultsender/${key}`, {}, headers).then((res) => {
                const status = res.data.status
                if(!status) {
                    return this.$router.push('/location/timeout')
                }
                const senderFind = this.senders.find(val => val.id === key)
                const nameString = senderFind['name'] + ' | ' + senderFind['tel']
                this.$liff.sendMessages(this.messageSendParcel(nameString)).then(() => {
                    console.log("message sent: ");
                })
                .catch((err) => {
                    console.log("error: ", err);
                })
            })
            this.$liff.closeWindow()
        },
        messageSendParcel(nameString) {
            const messageConsign = {
                "type": "bubble",
                "direction": "ltr",
                "header": {
                    "type": "box",
                    "layout": "vertical",
                    "paddingAll": "12px",
                    "paddingBottom": "0px",
                    "contents": [
                    {
                        "type": "text",
                        "text": "ผู้รับพัสดุ",
                        "weight": "bold",
                        "size": "lg",
                        "align": "start",
                        "contents": []
                    },
                    {
                        "type": "text",
                        "text": "กรุณาพิมพ์ที่อยู่ในการจัดส่งมาในแชท",
                        "weight": "regular",
                        "size": "sm",
                        "color": "#828282",
                        "align": "start",
                        "margin": "sm",
                        "position": "relative",
                        "contents": []
                    },
                    {
                        "type": "separator",
                        "margin": "12px",
                        "color": "#F2F2F2"
                    }
                    ]
                },
                "body": {
                    "type": "box",
                    "layout": "vertical",
                    "position": "relative",
                    "paddingAll": "12px",
                    "backgroundColor": "#FFFFFFFF",
                    "contents": [
                    {
                        "type": "text",
                        "text": "พิมพ์ \"ที่อยู่ในการจัดส่ง\" โดยเว้นวรรคดังนี้",
                        "size": "sm",
                        "align": "start",
                        "wrap": true,
                        "style": "normal",
                        "contents": [],
                        "weight": "bold"
                    }
                    ],
                    "paddingTop": "8px",
                    "paddingBottom": "8px"
                },
                "footer": {
                    "type": "box",
                    "layout": "horizontal",
                    "paddingAll": "3px",
                    "paddingBottom": "12px",
                    "contents": [
                    {
                        "type": "box",
                        "layout": "vertical",
                        "position": "relative",
                        "offsetStart": "10px",
                        "contents": [
                        {
                            "type": "text",
                            "text": "ชื่อผู้รับ",
                            "size": "sm",
                            "color": "#828282",
                            "contents": []
                        },
                        {
                            "type": "text",
                            "text": "เบอร์โทรศัพท์",
                            "weight": "regular",
                            "size": "sm",
                            "color": "#828282",
                            "contents": []
                        },
                        {
                            "type": "text",
                            "text": "ที่อยู่ (พร้อมรหัสไปรษณีย์)",
                            "weight": "regular",
                            "size": "sm",
                            "color": "#828282",
                            "contents": []
                        }
                        ]
                    }
                    ]
                }
                }
            const messageDeliver = {
                    "type": "bubble",
                    "direction": "ltr",
                    "header": {
                        "type": "box",
                        "layout": "vertical",
                        "position": "relative",
                        "paddingBottom": "0px",
                        "contents": [
                        {
                            "type": "text",
                            "text": "ผู้ส่งพัสดุ",
                            "weight": "bold",
                            "size": "lg",
                            "align": "start",
                            "contents": []
                        },
                        {
                            "type": "text",
                            "text": "ข้อมูลผู้ส่งจะแสดงบนใบปะหน้า",
                            "color": "#828282",
                            "contents": []
                        },
                        {
                            "type": "separator",
                            "margin": "md",
                            "color": "#F2F2F2"
                        }
                        ],
                        "paddingAll": "12px"
                    },
                    "body": {
                        "type": "box",
                        "layout": "horizontal",
                        "paddingTop": "5px",
                        "paddingBottom": "0px",
                        "contents": [
                        {
                            "type": "box",
                            "layout": "horizontal",
                            "position": "relative",
                            "paddingAll": "10px",
                            "contents": [
                            {
                                "type": "box",
                                "layout": "vertical",
                                "width": "19%",
                                "contents": [
                                {
                                    "type": "image",
                                    "url": this.$API_URL + "/assets/images/line/icon/home.png?1",
                                    "align": "start",
                                    "size": "xxs",
                                    "aspectMode": "cover"
                                }
                                ]
                            },
                            {
                                "type": "box",
                                "layout": "vertical",
                                "paddingTop": "10px",
                                "contents": [
                                {
                                    "type": "text",
                                    "text": nameString,
                                    "weight": "bold",
                                    "size": "14px",
                                    "align": "start",
                                    "gravity": "center",
                                    "wrap": true,
                                    "position": "relative",
                                    "contents": []
                                }
                                ]
                            }
                            ]
                        }
                        ],
                        "paddingAll": "12px"
                    },
                    "footer": {
                        "type": "box",
                        "layout": "vertical",
                        "contents": [
                        {
                            "type": "box",
                            "layout": "vertical",
                            "contents": [
                            {
                                "type": "button",
                                "action": {
                                "type": "uri",
                                "label": "เปลี่ยน",
                                "uri": formatLiff(context_line.liffId, 'showsenders', '')
                                },
                                "color": "#009EFF",
                                "style": "link"
                            }
                            ],
                            "cornerRadius": "5px",
                            "borderColor": "#009EFF",
                            "borderWidth": "1px"
                        }
                        ]
                    }
                }
            const templateMessage = [
                {
                    "type": "flex",
                    "altText": "ผู้ส่งพัสดุ",
                    "contents": messageDeliver
                },
                {
                    "type": "flex",
                    "altText": "โปรดพิมพ์ผู้รับพัสดุ",
                    "contents": messageConsign
                }
            ]
            const body = {
                cache: 'bookFirstStage',
                sendmessage: templateMessage
            }
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }

            this.$http.post(this.$API_URL + '/line/message/set/cache', body, headers).then((response) => {
                // const statusMessage = response.data.status
                // if(!statusMessage) {
                    
                // }
            })
            
        },
        getSendersCustomer() {
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            this.$http.post(this.$API_URL + "/line/get/senders", {}, headers).then((res) => {
                const status = res.data.status
                if(!status) {
                    return this.$router.push('/location/timeout')
                }
                this.senders = res.data.data
                this.selectedRadio = this.senders[0].id
                this.busy = false
            })
        },
        isHasDraft() {
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            this.$http.post(this.$API_URL + '/line/has/draft', {}, headers).then((res) => {
                const status = res.data.status
                if(!status) {
                    this.$router.push('/location/timeout')
                    return false
                }
            })
        }
    },
    mounted () {
        this.$liff.init({
            liffId: context_line.liffId
        })
        this.isHasDraft()
        this.getSendersCustomer()
    }
}
</script>